import { ReactNode } from "react";
import { LinkTerminosPrivacidad } from "@components/ui_v2";

/** Lo que cambia por empresa en "Crea tu cuenta" (`CrearCuenta`); la pantalla y su lógica son las mismas. */
export interface CrearCuentaConfig {
  /**
   * Leyenda de la casilla que se acepta para continuar, con sus enlaces. `null`: la pantalla no lleva casilla
   * (`S_Usuario consent="ninguno"` del prototipo) porque la empresa la acepta antes, en su cotizador.
   */
  terminosLabel: ReactNode | null;
}

const DEFAULT_CONFIG: CrearCuentaConfig = {
  terminosLabel: (
    <>
      Acepto los <LinkTerminosPrivacidad termsLabel="términos y condiciones" connector="y el" />
    </>
  ),
};

/** Por empresa (`getConfigName`); si la empresa no está aquí se usa el default. */
const crearCuentaPorEmpresa: Record<string, CrearCuentaConfig> = {
  // Mercader acepta el aviso de privacidad en su cotizador (`CotizadorMercader`), no aquí.
  mercader: {
    terminosLabel: null,
  },
};

export const getCrearCuentaConfig = (configName: string): CrearCuentaConfig =>
  crearCuentaPorEmpresa[configName] ?? DEFAULT_CONFIG;
